import cc from 'classcat';

import { CloudinaryImage } from '#src/components/CloudinaryImage';
import { flattenResponsiveImage } from '#src/lib/contentful/selectors.mjs';

import { H1, H5 } from './Headings.js';
import styles from './ProductHero.scss';
import { ProductHeroCTAs } from './ProductHeroCTAs/index.js';
import { HeadingAnimation } from './HeadingAnimation.js';

export function ProductHero({
  className,
  callToAction,
  ctaComponent,
  image,
  isDarkBackground,
  headline,
  secondaryCallsToAction,
  stickyCta,
  subline,
  theme,
  ...props
}) {
  return (
    <section
      className={cc([
        styles.container,
        styles[`bg${props.productHeroTheme}`],
        className,
      ])}
    >
      <div className={styles.content}>
        <header>
          {/* <H1>Lose Weight</H1> */}
          {/* {!!headline && <H1>{headline}</H1>} */}
          <HeadingAnimation />
          <H1>playing games. Seriously!</H1>
          {!!subline && <H5>{subline}</H5>}
          <ProductHeroCTAs
            items={[callToAction, ...(secondaryCallsToAction || [])]}
            theme={theme}
            isDarkBackground={isDarkBackground}
          />
        </header>
        {!!image && (
          <div className={styles.imageContainer}>
            <CloudinaryImage
              {...flattenResponsiveImage(image)}
              className={styles.image}
            />
          </div>
        )}
      </div>
    </section>
  );
}
